// extracted by mini-css-extract-plugin
export var conversationListItem = "_wz-2";
export var fullBleedList = "_wz-3";
export var messageText = "_wz-1";
export var previewText = "_wz-0";